import {
  List,
  Datagrid,
  TextField,
  TextInput,
  FunctionField,
  ReferenceField,
  type ListProps,
  type RaRecord,
} from "react-admin";
import { DisplayDateField } from "@/components/DisplayDateField";
import { formatListDate } from "@/utils/date-format";

const filters = [
  <TextInput key="q" source="q" label="Search name or ITS" alwaysOn sx={{ minWidth: 260 }} />,
];

const RazaRequestsList = (props: ListProps) => (
  <List {...props} filters={filters} sort={{ field: "updatedAt", order: "DESC" }}>
    <Datagrid rowClick="show">
      <FunctionField
        label="Raza granted on"
        sortBy="razaGranted"
        render={(record: RaRecord) => formatListDate(record?.razaGranted, { empty: "Pending" })}
      />
      <TextField source="itsNo" label="ITS" />
      <TextField source="name" label="Name" />
      <TextField source="mohallah" label="Mohallah" />
      <ReferenceField source="purpose" reference="bookingPurpose" label="Purpose">
        <TextField source="name" />
      </ReferenceField>
      <FunctionField
        label="Lagat total"
        render={(r: RaRecord) => {
          const n = Number(r.lagatReceiptTotalAmount);
          if (!Number.isFinite(n) || n <= 0) return "—";
          return new Intl.NumberFormat(undefined, {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 0,
          }).format(n);
        }}
      />
      <FunctionField
        label="Lagat"
        render={(r: RaRecord) => {
          const n = Number(r.lagatReceiptCount);
          if (!Number.isFinite(n) || n <= 0) return "—";
          const first =
            typeof r.lagatReceiptFirstNo === "string" ? r.lagatReceiptFirstNo.trim() : "";
          if (first) {
            return n > 1 ? `${n} · ${first}…` : first;
          }
          return `${n} receipt(s)`;
        }}
      />
      <DisplayDateField source="updatedAt" label="Updated" showTime />
    </Datagrid>
  </List>
);

export default RazaRequestsList;
